import { requiredUuidString } from '../zod-helpers/index.js';
import { withCalEventTemplateBody } from './with-cal-event-template-body.js';
export const updateCalEventTemplateInputSchema = withCalEventTemplateBody({
    templateVersionId: requiredUuidString('Template is required.', 'Invalid template ID.'),
});
//# sourceMappingURL=update-cal-event-template-input.js.map